import React, { Component } from 'react';

// Externals
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles';
// Material helpers
import { withStyles } from '@material-ui/core/styles';

// Material components
import Grid from '@material-ui/core/Grid';
import Popover from '@material-ui/core/Popover';
import Button from '@material-ui/core/Button';
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';
import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import QueryBuilderIcon from '@material-ui/icons/QueryBuilder';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import IconButton from '@material-ui/core/IconButton';
import RefreshIcon from '@material-ui/icons/Refresh';
import RestoreIcon from '@material-ui/icons/Restore';
import InfoIcon from '@material-ui/icons/Info';
import PortletToolbar from 'components/PortletToolbar';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import ClearIcon from '@material-ui/icons/Clear';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Hidden from '@material-ui/core/Hidden';
import Avatar from '@material-ui/core/Avatar';
import UpdateIcon from '@material-ui/icons/Update';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import ListObjectiveModal from '../ListObjectiveModal';
import GeneralStatusAvailabilityConsolidated from '../GeneralStatus/GeneralStatusAvailabilityConsolidated';
import Period from '../../../../helpers/PeriodGeneralStatus';
import { TableCell, Table, Box, Switch } from '@material-ui/core';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import highchartsMore from "highcharts/highcharts-more.js";
import xRange from "highcharts/modules/xrange.js";
import {
  getTimeStorageTimezone,
  substractTimeToStorageTimeZone,
} from "../../../../utils/fns/custom-time-fns";

import moment from 'moment-timezone'
import 'moment/locale/es'  
import { tr } from 'date-fns/locale';
moment.locale('es')
const date=((moment().locale('es')).format("dddd, DD/MM/YYYY, h:mm:ss a"))
highchartsMore(Highcharts);
xRange(Highcharts);
Highcharts.setOptions({
    lang: {
        months: [
            'Enero', 'Febrero', 'Marzo', 'Abril',
            'Mayo', 'Junio', 'Julio', 'Agosto',
            'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
        ],
        weekdays: [
            'Domingo', 'Lunes', 'Martes', 'Miércoles',
            'Jueves', 'Viernes', 'Sábado'
        ]
    }
});

/**
 * Determinar si el gráfico se actualizará de forma automática
 */
const autoRefreshSaved = localStorage.getItem('autoRefreshGeneralStatus')
const autoRefreshSavedValue = autoRefreshSaved === null || autoRefreshSaved === 'true'

/** Tiempo de refresco del componente */
const INTERVAL = 300000

class GeneralStatus extends Component {

    constructor(props) {
        super(props);
        this.handlePeriodClick = this.handlePeriodClick.bind(this);
        this.state = {
            isOpen: false,
            path: null,
            listObjectives: {},
            nameStatus: 'Objetivos ',
            selectedOption: null,
            loadObjectiveData: false,
            externalData: null,
            dataError: false,
            isLoading: true,
            sla: null,
            time: 'h',
            hoverData: null,
            lastEvent: [],
            isStatePeriod: false,
            settingsEl: null,
            isInfo: null,
            date: moment().tz(sessionStorage.getItem('tz')).format("dddd, DD/MM/YYYY, h:mm:ss a"),
            objmodal: 0,
            objNameModal: '',
            openObjectiveModal: false,
            typeGraph: 0,
            period: '',
            namePeriod: null,
            namePeriodPorlet: ['Última Hora', 'Últimas 3 horas', 'Últimas 6 horas', 'Últimas 12 horas', 'Último día', 'Últimos 2 días', 'Última semana', 'Últimas 2 semanas', 'Último mes', 'Seleccione Período'],
            typePeriod: 9,
            chartOptionsBase: this._chartOptionsBase,
            chartOptionsStackedBarConsolidated: this._chartOptionsBase,
            isRefresh: false,
            intervalId: null,
            autoRefresh: autoRefreshSavedValue,
            isSpecial: false,
        }

    }

    _chartOptionsBase = {

        chart: {
            type: 'xrange',
            height: 50,
        },
        title: {
            text: null
        },
        xAxis: {
            type: 'datetime',
            gridLineWidth: 0,
        },
        pane: {
            size: '150%',
        },
        yAxis: {
            title: {
                text: ''
            },
            categories: [''],
            gridLineWidth: 0,
            reversed: true,
            labels: {
                useHTML:true,//set to true
                style:{
                    whiteSpace:'normal'//set to normal
                },
                step: 1,
                formatter: function () {//use formatter
                    var objNameLabel = this.value
                    return '<div align="initial" style="word-wrap: break-word;word-break: break-all;width:200px"></div>';
                }
            },
        },
        series: [{
            //name: 'Project 1',
            // pointPadding: 0,
            // groupPadding: 0,
            //borderColor: 'gray',
            pointWidth: 40,
            turboThreshold: 0,
            /*animation: {
                duration: 10000,
                // Uses Math.easeOutBounce
                easing: 'easeOutBounce'
            },*/
            animation: false,
            /*dataLabels: {
                enabled: true
            }*/
            data: [{
                x: Date.UTC(2021, 2, 10,11,23,0),
                x2: Date.UTC(2021, 2, 10,12,23,0),
                y: 0,
                color: 'white'
            }]
        }],
       
        plotOptions: {
            series: {
                borderRadius: '0px',
                borderColor: 'transparent',
                pointWidth: 10,
                turboThreshold: 0,
                grouping: false,
                datalabels: false,
                        cursor: 'pointer',
                        point: {
                            events: {
                                //mouseOver: this.setHoverDataBar.bind(this),
                                //click: this.setClickDataBar.bind(this)
                            }
                        }
            }
        },
        credits: {
            enabled: false
        },
        tooltip: {
            xDateFormat: '%A, %b %e, %Y %H:%M:%S',
            enabled: false,
        },
        legend: {
            enabled: false
        },
    }
    
    setHoverData = (e) => {

        const { params } = this.state
        let name = e.point.name
        this.setState({
            isOpen: true,
            nameStatus: 'Objetivos ' + name,
            listObjectives: params[name]
        });
    }
    setHoverDataBar = (e) => {

        const { params } = this.state
        const { category, series } = e.point
        let nameCat = category
        let nameStatus = series.name
        var filterParams = params[nameStatus].filter(param => param['grupo_servicio_unificado'] == nameCat)
        this.setState({
            isOpen: true,
            nameStatus: 'Objetivos ' + nameCat,
            listObjectives: filterParams
        });
    }
    onOpenModal = () => {
        this.setState({ isOpen: true });
    };

    onCloseModal = () => {
        this.setState({ isOpen: false });
    };
    tick=()=>{
        sessionStorage.setItem("listsLoadsDisponibilidad",false)
        //sessionStorage.setItem("listsLoads",false)
        this.setState({
            loadObjectiveData: false,
            isLoading: true,
            settingsEl: null,
            isRefresh: true,
            date: moment().tz(sessionStorage.getItem('tz')).format("dddd, DD/MM/YYYY, h:mm:ss a"),
        })
        this.processData()
      }

    componentDidMount() {
      this.processData()
      if (this.state.autoRefresh) {
        const newIntervalId = setInterval(() => this.tick(), INTERVAL);

        this.setState({ intervalId: newIntervalId });
      }
    }
    
    componentDidUpdate(prevProps, prevState) {
        if (!this.state.loadObjectiveData) {
          // this.processData()
        }
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId)
    }

    processData = () => {
        const { params } = this.props;
        var data = params
        if((sessionStorage.getItem("listsLoads"))==="true"){
            data = JSON.parse(sessionStorage.getItem("listaData"))
        }
        return new Promise(resolve => {
            setTimeout(() => {
                
                const {chartOptionsBase, isRefresh, period} = this.state;
                var period_semaphore = sessionStorage.getItem('period_semaphore');
                const newChecked = chartOptionsBase;

                let objectivesList = []
                Object.keys(data).map((key) => {
                    if (key !== 'Services' && key !=='ServicesUnified') {
                        Object(data[key]).map((objective, orden)=>{
                            objectivesList.push(objective)
                        })
                    } 
                })
                var order = {'Downtime': 1, "Parcial": 2, "Uptime": 3, "No monitoreo": 4};
                objectivesList.sort(function (a, b) {
                    var priorityA = order[a.estado] || Infinity;
                    var priorityB = order[b.estado] || Infinity;

                    var nombreA = (a.nombre).toLowerCase()
                    var nombreB = (b.nombre).toLowerCase()

                    if (priorityA < priorityB) return -1;
                    if (priorityA > priorityB) return 1;

                    if (nombreA < nombreB) return -1;
                    if (nombreA > nombreB) return 1;
                    return 0;
                })

                if (isRefresh){
                    if (period == 'h'){
                        period_semaphore = '3600'
                    }else if (period == '3h'){
                        period_semaphore = '10800'
                    }else if (period == '6h'){
                        period_semaphore = '21600'
                    }else if (period == '12h'){
                        period_semaphore = '43200'
                    }else if (period == 'd'){
                        period_semaphore = '86400'
                    }else if (period == '2d'){
                        period_semaphore = '172800'
                    }else if (period == 'w'){
                        period_semaphore = '604800'
                    }else if (period == '2w') {
                        period_semaphore = '1209600'
                    }else if (period == 'm') {
                        let hoy = new Date();
                        let mesPasado = new Date();
                        mesPasado.setMonth(hoy.getMonth() - 1);
                        let diferencia = hoy.getTime() - mesPasado.getTime();
                        let seg = Math.floor(diferencia / 1000);
                        period_semaphore = seg
                    }
                }
                //fecha final
                var dateMomentEnd =  moment().tz(sessionStorage.getItem('tz')).format("MM/DD/YYYY h:mm:ss a")
                var dateJsonEnd = new Date(dateMomentEnd)
                let yearEnd = dateJsonEnd.getFullYear()
                let monthEnd = dateJsonEnd.getMonth()
                let dayEnd = dateJsonEnd.getDate()
                let hoursEnd = dateJsonEnd.getHours()
                let minutesEnd = dateJsonEnd.getMinutes()
                let secondsEnd = dateJsonEnd.getSeconds()
                //fecha inicial
                var dateMoment =  moment().tz(sessionStorage.getItem('tz')).subtract(parseInt(period_semaphore),'seconds').format("MM/DD/YYYY h:mm:ss a")
                var dateJson = new Date(dateMoment)
                let year = dateJson.getFullYear()
                let month = dateJson.getMonth()
                let day = dateJson.getDate()
                let hours = dateJson.getHours()
                let minutes = dateJson.getMinutes()
                let seconds = dateJson.getSeconds()
                newChecked['series'] =  [{
                    pointWidth: 40,
                    turboThreshold: 0,
                    animation: false,
                    data: [{
                        x: Date.UTC(year,(month),day,hours,minutes,seconds),
                        x2: Date.UTC(yearEnd,(monthEnd),dayEnd,hoursEnd,minutesEnd,secondsEnd),
                        y: 0,
                        color: 'white'
                    }]
                }]

                let hoy = new Date();
                let mesPasado = new Date();
                mesPasado.setMonth(hoy.getMonth() - 1);
                let diferencia = hoy.getTime() - mesPasado.getTime();
                let hora = Math.floor(diferencia / (1000 * 60 * 60));

                var periodtransform = parseInt(period_semaphore) / 60 / 60
                var periodCustom = ''
                if (periodtransform == 1){
                    periodCustom = 'h'
                }else if (periodtransform == 3){
                    periodCustom = '3h'
                }else if (periodtransform == 6){
                    periodCustom = '6h'
                }else if (periodtransform == 12){
                    periodCustom = '12h'
                }else if (periodtransform == 24){
                    periodCustom = 'd'
                }else if (periodtransform == 48){
                    periodCustom = '2d'
                }else if (periodtransform == 168){
                    periodCustom = 'w'
                }else if (periodtransform == 336) {
                    periodCustom = '2w'
                }else if (periodtransform == hora) {
                    periodCustom = 'm'
                }

                this.setState({
                    objectivesList: objectivesList,
                    loadObjectiveData: true,
                    listObjetivesData: data,
                    isLoading: false,
                    params: data,
                    date: moment().tz(sessionStorage.getItem('tz')).format("dddd, DD/MM/YYYY, h:mm:ss a"),
                    chartOptionsStackedBarConsolidated: newChecked,
                    period: periodCustom,
                    isRefresh: false
                });
                resolve(true);

            }, 2000);
        });

    }

    handleCloseIsInfo = () => {
        this.setState({
            isInfo: null
        });
    };

    handleChange = (selectedOption) => {
        const { passProps } = this.props
        this.setState({ selectedOption });
        //passProps.onClick(passProps, selectedOption.value)
    };
    
    handleShowSettings = event => {
        this.setState({
            settingsEl: event.currentTarget
        });
    };
    handleCloseSettings = () => {
        this.setState({
            settingsEl: null
        });
    };

    handleRefresh = () => {
        if (this.state.autoRefresh) {
            clearInterval(this.state.intervalId);
            const newIntervalId = setInterval(() => this.tick(), INTERVAL);
            this.setState({ intervalId: newIntervalId });
        }
        this.tick()
        this.setState({
            loadObjectiveData: false,
            isLoading: true,
            settingsEl: null,
            isRefresh: true
        });
    };
    handleDefault = () => {
        this.setState({
            loadObjectiveData: false,
            isLoading: true,
            settingsEl: null,
            isRefresh: false,
            typePeriod: 9,
            date: moment().tz(sessionStorage.getItem('tz')).format("dddd, DD/MM/YYYY, h:mm:ss a")
        });
      this.processData()
    };

    handleShowIsInfo = event => {
        this.setState({
            isInfo: event.currentTarget
        });
    };

    
    handleOpenObjectiveModal = event => {      
        const objId = event.currentTarget.id
        const objName = event.currentTarget.value       
        if (this.state.openObjectiveModal == false){
            this.setState({
                openObjectiveModal: true,
                objIdModal: objId,
                objNameModal: objName
            })
        }        
    };
    
    handleCloseObjectiveModal  = event => {
        this.setState({
            openObjectiveModal: false,
        })
    };

    handleShowPeriod = event => {
        this.setState({
            periodEl: event.currentTarget
        });
    };

    handleClosePeriod = () => {
        this.setState({
            periodEl: null
        });
    };

    handlePeriodClick(prevPeriod, prevTypeGraph, statePeriod, nextPeriod) {
        const {
          yearEnd,
          monthEnd,
          dayEnd,
          hoursEnd,
          minutesEnd,
          secondsEnd,
        } = getTimeStorageTimezone();
        const {
          year,
          month,
          day,
          hours,
          minutes,
          seconds,
        } = substractTimeToStorageTimeZone(1, "hour");
        // selectedPeriodState son los nuevos datos del state para actualizar los datos
        var selectedPeriodState = {
          typeGraph: prevTypeGraph,
          isStatePeriod: false,
          periodEl: null,
          isRefresh: false,
          chartOptionsStackedBarConsolidated: {
            series: [
              {
                data: [
                  {
                    x: Date.UTC(year, month, day, hours, minutes, seconds),
                    x2: Date.UTC(
                      yearEnd,
                      monthEnd,
                      dayEnd,
                      hoursEnd,
                      minutesEnd,
                      secondsEnd
                    ),
                    y: 0,
                    color: "white",
                  },
                ],
              },
            ],
          },
        };

        if (nextPeriod === "hora") {
          const {
            year,
            month,
            day,
            hours,
            minutes,
            seconds,
          } = substractTimeToStorageTimeZone(1, "hour");

          selectedPeriodState = {
            ...selectedPeriodState,
            period: "h",
            typePeriod: 0,
            chartOptionsStackedBarConsolidated: {
              series: [
                {
                  data: [
                    {
                      x: Date.UTC(year, month, day, hours, minutes, seconds),
                      x2: Date.UTC(
                        yearEnd,
                        monthEnd,
                        dayEnd,
                        hoursEnd,
                        minutesEnd,
                        secondsEnd
                      ),
                      y: 0,
                      color: "white",
                    },
                  ],
                },
              ],
            },
          };
        } else if (nextPeriod === "3hora") {
          const {
            year,
            month,
            day,
            hours,
            minutes,
            seconds,
          } = substractTimeToStorageTimeZone(3, "hour");

          selectedPeriodState = {
            ...selectedPeriodState,
            period: "3h",
            typePeriod: 1,
            chartOptionsStackedBarConsolidated: {
              series: [
                {
                  data: [
                    {
                      x: Date.UTC(year, month, day, hours, minutes, seconds),
                      x2: Date.UTC(
                        yearEnd,
                        monthEnd,
                        dayEnd,
                        hoursEnd,
                        minutesEnd,
                        secondsEnd
                      ),
                      y: 0,
                      color: "white",
                    },
                  ],
                },
              ],
            },
          };
        } else if (nextPeriod === "6hora") {
          const {
            year,
            month,
            day,
            hours,
            minutes,
            seconds,
          } = substractTimeToStorageTimeZone(6, "hour");

          selectedPeriodState = {
            ...selectedPeriodState,
            period: "6h",
            typePeriod: 2,
            chartOptionsStackedBarConsolidated: {
              series: [
                {
                  data: [
                    {
                      x: Date.UTC(year, month, day, hours, minutes, seconds),
                      x2: Date.UTC(
                        yearEnd,
                        monthEnd,
                        dayEnd,
                        hoursEnd,
                        minutesEnd,
                        secondsEnd
                      ),
                      y: 0,
                      color: "white",
                    },
                  ],
                },
              ],
            },
          };
        } else if (nextPeriod === "12hora") {
          const {
            year,
            month,
            day,
            hours,
            minutes,
            seconds,
          } = substractTimeToStorageTimeZone(12, "hour");

          selectedPeriodState = {
            ...selectedPeriodState,
            period: "12h",
            typePeriod: 3,
            chartOptionsStackedBarConsolidated: {
              series: [
                {
                  data: [
                    {
                      x: Date.UTC(year, month, day, hours, minutes, seconds),
                      x2: Date.UTC(
                        yearEnd,
                        monthEnd,
                        dayEnd,
                        hoursEnd,
                        minutesEnd,
                        secondsEnd
                      ),
                      y: 0,
                      color: "white",
                    },
                  ],
                },
              ],
            },
          };
        } else if (nextPeriod === "dia") {
          const {
            year,
            month,
            day,
            hours,
            minutes,
            seconds,
          } = substractTimeToStorageTimeZone(1, "day");

          selectedPeriodState = {
            ...selectedPeriodState,
            period: "d",
            typePeriod: 4,
            chartOptionsStackedBarConsolidated: {
              series: [
                {
                  data: [
                    {
                      x: Date.UTC(year, month, day, hours, minutes, seconds),
                      x2: Date.UTC(
                        yearEnd,
                        monthEnd,
                        dayEnd,
                        hoursEnd,
                        minutesEnd,
                        secondsEnd
                      ),
                      y: 0,
                      color: "white",
                    },
                  ],
                },
              ],
            },
          };
        } else if (nextPeriod === "2dia") {
          const {
            year,
            month,
            day,
            hours,
            minutes,
            seconds,
          } = substractTimeToStorageTimeZone(2, "day");

          selectedPeriodState = {
            ...selectedPeriodState,
            period: "2d",
            typePeriod: 5,
            chartOptionsStackedBarConsolidated: {
              series: [
                {
                  data: [
                    {
                      x: Date.UTC(year, month, day, hours, minutes, seconds),
                      x2: Date.UTC(
                        yearEnd,
                        monthEnd,
                        dayEnd,
                        hoursEnd,
                        minutesEnd,
                        secondsEnd
                      ),
                      y: 0,
                      color: "white",
                    },
                  ],
                },
              ],
            },
          };
        } else if (nextPeriod === "semana") {
          const {
            year,
            month,
            day,
            hours,
            minutes,
            seconds,
          } = substractTimeToStorageTimeZone(7, "day");

          selectedPeriodState = {
            ...selectedPeriodState,
            period: "w",
            typePeriod: 6,
            chartOptionsStackedBarConsolidated: {
              series: [
                {
                  data: [
                    {
                      x: Date.UTC(year, month, day, hours, minutes, seconds),
                      x2: Date.UTC(
                        yearEnd,
                        monthEnd,
                        dayEnd,
                        hoursEnd,
                        minutesEnd,
                        secondsEnd
                      ),
                      y: 0,
                      color: "white",
                    },
                  ],
                },
              ],
            },
          };
        } else if (nextPeriod === "2semana") {
          const {
            year,
            month,
            day,
            hours,
            minutes,
            seconds,
          } = substractTimeToStorageTimeZone(14, "day");

          selectedPeriodState = {
            ...selectedPeriodState,
            period: "2w",
            typePeriod: 7,
            chartOptionsStackedBarConsolidated: {
              series: [
                {
                  data: [
                    {
                      x: Date.UTC(year, month, day, hours, minutes, seconds),
                      x2: Date.UTC(
                        yearEnd,
                        monthEnd,
                        dayEnd,
                        hoursEnd,
                        minutesEnd,
                        secondsEnd
                      ),
                      y: 0,
                      color: "white",
                    },
                  ],
                },
              ],
            },
          };
        } else if (nextPeriod === "mes") {
          //Obtener cantidad de que transcurriendo desde el mes anterior
          const hoy = new Date();
          const mesPasado = new Date();
          mesPasado.setMonth(hoy.getMonth() - 1);
          const diferencia = hoy.getTime() - mesPasado.getTime();
          const dias = Math.floor(diferencia / (1000 * 60 * 60 * 24));

          const {
            year,
            month,
            day,
            hours,
            minutes,
            seconds,
          } = substractTimeToStorageTimeZone(dias, "day");

          selectedPeriodState = {
            ...selectedPeriodState,
            period: "m",
            typePeriod: 8,
            chartOptionsStackedBarConsolidated: {
              series: [
                {
                  data: [
                    {
                      x: Date.UTC(year, month, day, hours, minutes, seconds),
                      x2: Date.UTC(
                        yearEnd,
                        monthEnd,
                        dayEnd,
                        hoursEnd,
                        minutesEnd,
                        secondsEnd
                      ),
                      y: 0,
                      color: "white",
                    },
                  ],
                },
              ],
            },
          };
        }
        this.setState({...selectedPeriodState, date: moment().tz(sessionStorage.getItem('tz')).format("dddd, DD/MM/YYYY, h:mm:ss a")});
    }

    handleChangeAutoRefresh = (event) => {
      const newValue = !Boolean(event.target.value === 'true')

      if (newValue) {
        clearInterval(this.state.intervalId);
        const newIntervalId = setInterval(() => this.tick(), INTERVAL);
        this.setState({ intervalId: newIntervalId });
      } else {
        clearInterval(this.state.intervalId)
      }
      localStorage.setItem('autoRefreshGeneralStatus', newValue)
      this.setState({ autoRefresh: newValue })
    }

    changeIsSpecialSwitch = () => {
      const newValue = this.state.isSpecial
      this.setState({isSpecial: !newValue})
    }

    render() {
        const { dataError, chartOptions, chartOptionsStackedBarConsolidated, isLoading, isOpen, listObjectives, selectedOption, nameStatus, 
            date, settingsEl, isInfo, objectivesList, loadObjectiveData, listObjetivesData,
            objIdModal, objNameModal, openObjectiveModal, periodEl, typeGraph, period, isOneHour, namePeriodPorlet, typePeriod} = this.state;
        const { classes, className, handleClose, isForModal, ...rest } = this.props;
        const style = isLoading ? { display: 'none' } : {maxWidth:'100vw', padding:'0px'};
        const styleHidden = isLoading ? {} : { display: 'none' };
        const rootClassName = classNames(classes.root, className);
        const showSettingsEl = Boolean(settingsEl);
        const showIsInfo = Boolean(isInfo);
        const showPeriodEl = Boolean(periodEl);
        let isForModalEl = false
        if (isForModal == true){
            isForModalEl = true
        }
        //console.log(chartOptionsStackedBarConsolidated)
        const divStyle = {
            top: '12%',left: '20%', width:'60%'
          };
        return (
            <Portlet className={rootClassName}>
                <PortletHeader style={{height: "100px"}}>
                {/* <PortletLabel
                            variant="h6"
                            title="Estado General"
                        /> */}
						<Grid container>
						<Grid item lg={6} md={6} sm={12} xs={12}>
                        <div style={{
							display: 'flex',
							alignItems: 'center'
						}}>
                            <Hidden only={["xs", 'sm']}><Avatar variant="rounded" className={classes.rounded}>
                            <UpdateIcon /> 
                            </Avatar>
                            <Typography  className={classes.updateTime}   >
                                    &nbsp; Última actualización: {date} 
                            </Typography></Hidden>
                        </div>
						</Grid>
						<Grid item lg={6} md={6} sm={12} xs={12}>
                        <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'end',
                                }}>
                             <Button variant="h4" style={{fontSize:'15px',float:'left', color:'#66788A'}} onClick={this.handleShowPeriod}>
                                {namePeriodPorlet[typePeriod]}<ArrowDropDownIcon />
                            </Button>
                            <IconButton
                                onClick={this.handleShowSettings}
                                styles={{float:'right'}}
                            >
                                <SettingsOutlinedIcon />
                            </IconButton>
                            {isForModalEl ?
                                <IconButton 
                                    onClick={handleClose}
                                >
                                    <ClearIcon/>
                                </IconButton>
                            : null}
                        </div>
						</Grid>
						<Grid item lg={12} md={12} sm={12} xs={12}>
							<Box display='flex' alignItems='center' justifyContent='end'>
								<Typography variant='h6' style={{color: "#6b6b6b"}}>
									Estado general especial
								</Typography>
								<Box style={{marginLeft: '10px', marginRight: '10px'}}>
									<Switch
										checked={this.state.isSpecial}
										onChange={() => this.changeIsSpecialSwitch()}
										inputProps={{ 'aria-label': 'secondary checkbox' }}
										color='primary'
									/>
								</Box>
							</Box>
						</Grid>
					</Grid>
                    <Popover
                        anchorEl={periodEl}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center'
                        }}
                        onClose={this.handleClosePeriod}
                        open={showPeriodEl}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center'
                        }}>
                        <Period onClick={this.handlePeriodClick} period={period} typeGraph={typeGraph} isOneHour={isOneHour}/>
                    </Popover>
                    <Popover
                        anchorEl={settingsEl}
                        onClose={this.handleCloseSettings}
                        open={showSettingsEl}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                            }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                    }}
                    >
                        <IconButton color="primary" style={{display: 'flex', justifyContent: 'space-between', color:'#66788A'}} onClick={this.handleRefresh}>
                            <RefreshIcon color="primary" style={{ color:'#66788A'}} />
                            <Typography variant="h4" style={{fontSize:'15px',float:'right', paddingLeft:'5px', color:'#66788A'}}>
                                Actualizar
                            </Typography>
                        </IconButton>
                        <IconButton color="primary" style={{display: 'flex', justifyContent: 'space-between'}} onClick={this.handleDefault}>
                            <RestoreIcon color="primary" style={{ color:'#66788A'}} />
                            <Typography variant="h4" style={{fontSize:'15px',float:'right', paddingLeft:'5px', color:'#66788A'}}>
                                Periodo por Defecto
                            </Typography> 
                        </IconButton>
                        <Box display='flex'>
                            <Switch
                                value={this.state.autoRefresh}
                                checked={this.state.autoRefresh}
                                onChange={this.handleChangeAutoRefresh}
                                color="primary"
                                style={{margin: 0}}
                            />
                            <Box>
                                <Typography variant="h4" style={{fontSize:'15px', paddingLeft:'5px', color:'#66788A', marginBottom: -5}}>
                                    Auto refrescar
                                </Typography>
                                <Typography style={{fontSize: '10px', color:'#66788A', paddingLeft:'5px'}}>
                                    (5 mins.)
                                </Typography>
                            </Box>
                        </Box>
                        {/*<IconButton
                            onClick={this.handleShowIsInfo}
                            onClose={this.handleCloseIsInfo}
                            >
                            <div>
                                <InfoIcon color="secondary"/>
                                    <Typography variant="h4" 
                                        style={{fontSize:'15px',float:'right', paddingLeft:'5px', color:'#66788A'}}
                                        >Información
                                    </Typography>
                            </div>
                        </IconButton>
                        <Popover
                            //anchorEl={settingsEl}
                            open={showIsInfo}
                            onClose={this.handleCloseIsInfo}
                            style={divStyle}
                        >
                            <PortletContent>
                                <Typography align= "center" variant="h4" style={{fontSize:'13px',float:'center', color:'#66788A'}}>
                                    Grafico a la izquierda corresponse a la cantidad de monitoreos según su estado, 
                                    mientras que el gráfico a la derecha, los monitoreos están agrupados por servicio.
                                    Esta sección se actualiza de forma automatica cada 5 minutos.  </Typography>
                            </PortletContent>
                        </Popover>    */}                 
                </Popover>
                </PortletHeader>
                <PortletContent className={classes.content}>
                    {loadObjectiveData ?
                        <FormattedChart 
                            period={period}
                            handleOpen={this.handleOpenObjectiveModal}
                            listObjectives={objectivesList} 
                            chartOptions={chartOptions} 
                            chartOptionsStackedBarConsolidated={chartOptionsStackedBarConsolidated} 
                            style={style} styleHidden={styleHidden} classes={classes} date={date}
                            isSpecial={this.state.isSpecial}
                        />
                    :  <PerfectScrollbar>
                            <Typography
                                variant="h5"
                                align="center">
                                <CircularProgress
                                    variant="indeterminate"
                                    size={24}
                                    thickness={4}
                                    />
                                <br/>
                                Cargando Información...
                            </Typography>
                        </PerfectScrollbar>}
                        <Modal
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        open={openObjectiveModal}
                        onClose={this.handleClose}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                        closeAfterTransition
                        disableAutoFocus={true}
                        disableEnforceFocus={true}
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 500,
                        }}
                    >                                    
                        <Fade in={openObjectiveModal}>
                            <PerfectScrollbar style={{position:"static"}}>
                            <div className={classes.div}>                             
                                <ListObjectiveModal obj={objIdModal} objName={objNameModal} listObjectives={listObjetivesData} handleClose={this.handleCloseObjectiveModal}/>                        
                            </div>
                            </PerfectScrollbar>
                        </Fade>
                    </Modal>
                </PortletContent>
                
            </Portlet>
        )
    }
}

function FormattedChart(props) {
    return ( 
        <div>
            <div style={props.style}>
                <Grid
                    container
                    style={{display: "flex", justifyContent: "center"}}
                >            
                    <Grid item
                        sm={12}
                        xl={12}
                        xs={12}
                        > 
                        <div style={{display: "flex", justifyContent: "center"}}>
                          <div style={{maxWidth:'80vw', minWidth:'80vw', marginLeft: 22, paddingRight: 22}}>
                            <HighchartsReact
                                highcharts={Highcharts}
                                options={props.chartOptionsStackedBarConsolidated} />
                          </div>
                        </div>
                        <Grid item
                        sm={12}
                        xl={12}
                        xs={12}
                        >
                          <div style={{width: "100%"}}>
                            {props.period.length !=0 ? Object.keys(props.listObjectives).map(key => (
                                <div id={props.listObjectives[key].objetivo_id} value={props.listObjectives[key].nombre} onClick={props.handleOpen} style={{display: "flex", justifyContent: "center"}}>
                                    <GeneralStatusAvailabilityConsolidated objetivo_name={props.listObjectives[key].nombre} objetivo_id={props.listObjectives[key].objetivo_id} period={props.period} isSpecial={props.isSpecial}/>
                                </div>
                            )):"SELECCIONE PERÍODO"}
                          </div>
                        </Grid>
                    </Grid>     
                </Grid>     
            </div>   
        </div>           
    )
}

function groupBy(objectArray, property) {
    return objectArray.reduce(function (acc, obj) {
        var key = obj[property];
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
    }, {});
}
GeneralStatus.propTypes = {
    className: PropTypes.string,
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(GeneralStatus);